import Vue from 'vue'
import Vuetify from 'vuetify'
import ja from 'vuetify/src/locale/ja.ts'

Vue.use(Vuetify, {
  lang: {
    locales: { ja },
    current: 'ja'
  },
  theme: {
    primary: '#343469',
    secondary: '#514D99',
    accent: '#343469'
  }
})


// WEBPACK FOOTER //
// ./resources/js/plugins/vuetify.js